/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PPX from '../../vendor/ppx'
import env from '../env'
import URI from 'urijs'
import Backbone from '@polleverywhere/backbone'
import $ from 'jquery'

export default class AuthToken {
  get url () { return '/api/participant_auth_token' }
  get logoutUrl () { return '/api/participant_auth_token/logout' }

  constructor (token) {
    this.token = token
  }

  /*
   * Attempt to grab a token from www.polleverywhere.com through the PPX
   * iframe proxy and log in with it (through the Nginx proxy).
   */
  authenticate () {
    const deferred = $.Deferred()

    this.getCachedOrNewToken()
      .then(json => {
        this.post(json).then(deferred.resolve, deferred.reject)
      }).fail(deferred.reject)

    return deferred.promise()
  }

  getCachedOrNewToken () {
    const deferred = $.Deferred()

    if (this.token != null) {
      deferred.resolve({ token: this.token })
    } else {
      this.get().then(deferred.resolve, deferred.reject)
    }

    return deferred.promise()
  }

  logout () {
    /*
     * Why a GET for logout? We don't want to allow DELETE requests via this
     * proxy because DELETE requests are more risky.
     * We already allow logout via GET (www.polleverywhere.com/logout) so this
     * isn't an extra risk.
     */
    return this.get(this.logoutUrl)
  }

  ppxClient () {
    if (this._ppxClient) { return this._ppxClient }

    const ppxUrl = env.get('api_url').path('/ppx_proxy')
    this._ppxClient = PPX.buildClientConstructor(ppxUrl.toString())
    return this._ppxClient
  }

  post (tokenJson) {
    return Backbone.ajax({
      dataType: 'json',
      method: 'POST',
      url: this.url,
      data: tokenJson
    })
  }

  get (url) {
    /*
     * This is using our PPX proxy, so we don't want any of our CSRF or Proxy
     * code being run.
     */
    if (!url) { url = this.url }

    return $.ajax({
      dataType: 'json',
      url: URI(url).absoluteTo(env.get('api_url').toString()).toString(),
      xhr: this.ppxClient()
    })
  }
}
